import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {ParterParamsModel, Partner} from '../models/Partner'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/partner`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: `Bearer ${auth?.access_token ?? ''}`}

export async function getPartneri(params: ParterParamsModel) {
  return await axios.get<Array<Partner>>(API, {headers: headers, params: params})
}

export async function vozaciSearch(params: {search: string}) {
  return await axios.get(`${API}/vozaci-search`, {headers: headers, params})
}

export async function savePartner(Data: any) {
  return await axios.post(API, Data, {headers: headers})
}

export async function fetchPartner(Id: number): Promise<Partial<Partner>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching Odjel data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updatePartner(Data: any, id: number) {
  return await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
}

export async function deletePartner(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete Boja.')
    }
  } catch (error: any) {
    console.error('Error deleting Boja data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
